import React from "react";
import { Stack } from "@mui/material";
import AuthPoster from "../../components/auth/posterSection";
import Poster from "../../images/auth/reset-password.png";
import VerifyOtp from "../../components/auth/verifyOtp/verifyOtp";

function VerifyOtpPage() {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={0}
      sx={{ bgcolor: "#F8FBFE", position: "relative" }}
    >
      <AuthPoster PosterImage={Poster} />
      <VerifyOtp />
    </Stack>
  );
}

export default VerifyOtpPage;
